"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var nextUniqueId = 0;
function getNextUniqueId() {
    return nextUniqueId++;
}
exports.default = getNextUniqueId;
//# sourceMappingURL=getNextUniqueId.js.map


//////////////////
// WEBPACK FOOTER
// ./~/dnd-core/lib/utils/getNextUniqueId.js
// module id = 1862
// module chunks = 0